import EditQuoteDrawer from './EditQuoteDrawer';

export default EditQuoteDrawer;
